import { animate, state, style, transition, trigger } from '@angular/animations';

export const contentFade = [
  trigger('contentFade', [
    state('in', style({ opacity: 1 })),
    transition(':enter', [style({ opacity: 0, height: '*' }), animate(900)]),
    transition(':leave', animate(900, style({ opacity: 0 }))),
  ])
];
